import React from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as InfoCircle } from 'assets/icons/info-circle.svg';

const Tooltip = ({
  text,
  className,
  contentClass,
  Icon,
  testId,
  iconClassName,
  onClickIcon,
}) => {
  return (
    <div className={`has-tooltip ml-2 ${className}`}>
      <Icon
        data-testid={testId}
        onClick={onClickIcon}
        className={iconClassName}
      />
      <p className={`tooltip h-auto shadow-md rounded text-sm ${contentClass}`}>
        {text}
      </p>
    </div>
  );
};

Tooltip.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
  contentClass: PropTypes.string,
  Icon: PropTypes.shape({}),
  testId: PropTypes.string,
};

Tooltip.defaultProps = {
  text: '',
  className: 'relative mt-0.5',
  contentClass:
    '-left-10 lg:left-2 top-3 p-5 w-80 text-javelin-gray-dark bg-white',
  Icon: InfoCircle,
  iconClassName:
    'w-4 h-4 text-javelin-gray-dark text-opacity-40 fill-current cursor-pointer transition-all duration-200 ease-in-out',
  testId: 'tooltip',
};
export default Tooltip;
